export default __webpack_public_path__ + "static/media/Employer.788c14db.jpg";